import axios from "axios";
import memory from "../utils/memory";

export default function ajax(url, data={}, type='GET')
{
    // 本地测试
    // let base_path = 'http://project16.cn';
    
    // 线上环境
    let base_path = 'https://affiliate-api.giraffly.com';

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + memory.user_info.token;

    if(type === 'GET')
    {
        return axios.get(base_path + url, {params: data})
    }
    else
    {
        return axios.post(base_path + url, data)
    }
}